import addError from '../../../utils/error.jsx';

export function request(id, marketId, eventId, selection) {
    return {
        type: 'SELECTIONS_UPDATE_REQUEST',
        selection,
        marketId,
        eventId,
        id
    };
}

export function error(id, errors) {
    addError(errors);

    return {
        type: 'SELECTIONS_UPDATE_ERROR',
        errors,
        id
    };
}

export function update(id, data) {
    return {
        type: 'SELECTION_DATA',
        data,
        id
    };
}

export function finish(id, selection) {
    return (dispatch) => {
        dispatch(update(id, selection));

        dispatch({
            type: 'SELECTIONS_UPDATE_FINISH',
            selection,
            id
        });
    };
}

export function bulk(data) {
    return {
        type: 'SELECTIONS_DATA',
        data
    };
}
